export const TypeLoc = 'loc';
export const TypeMap = 'map';
export const TypeSat = 'sat';
export const TypeFlightPlanning = 'flight-planning';
